import axios from "axios";
import { apiVariable } from "./apiVariable";
import {
  RecruitingContactDto,
  RecruitingContactImportResultDto,
  RecruitingContactStatisticsDto,
} from "../interfaces/Recruiting/recruitingContact";

export const getRecruitingContacts = async (
  token: string,
  fromDate?: string,
  toDate?: string,
  status?: string,
): Promise<RecruitingContactDto[]> => {
  const params: { fromDate?: string; toDate?: string; status?: string } = {};

  if (fromDate) {
    params.fromDate = fromDate;
  }

  if (toDate) {
    params.toDate = toDate;
  }

  if (status) {
    params.status = status;
  }

  const { data } = await axios.get<RecruitingContactDto[]>(
    `${apiVariable}/recruiting/contacts`,
    {
      params: Object.keys(params).length ? params : undefined,
      headers: { Authorization: `Bearer ${token}` },
    },
  );

  return data;
};

export const importRecruitingContacts = async (
  token: string,
  file: File,
  contactDate?: string,
): Promise<RecruitingContactImportResultDto> => {
  const formData = new FormData();
  formData.append("file", file);

  const { data } = await axios.post<RecruitingContactImportResultDto>(
    `${apiVariable}/recruiting/contacts/import`,
    formData,
    {
      params: contactDate ? { contactDate } : undefined,
      headers: { Authorization: `Bearer ${token}` },
    },
  );

  return data;
};

export const getRecruitingContactStatistics = async (
  token: string,
  year: number,
  month: number,
): Promise<RecruitingContactStatisticsDto> => {
  const { data } = await axios.get<RecruitingContactStatisticsDto>(
    `${apiVariable}/recruiting/contacts/statistics`,
    {
      params: { year, month },
      headers: { Authorization: `Bearer ${token}` },
    },
  );

  return data;
};
